import { CandidateCardComponent } from "./candidate-card.component";
export const CandidateCardModule = angular
    .module('candidateCard', [])
    .component(CandidateCardComponent.selector, CandidateCardComponent.component)
    .name;
//# sourceMappingURL=candidate-card.module.js.map